import { render } from "./EmptyHint.vue?vue&type=template&id=b832db44&scoped=true&ts=true"
import script from "./EmptyHint.vue?vue&type=script&lang=ts"
export * from "./EmptyHint.vue?vue&type=script&lang=ts"

import "./EmptyHint.vue?vue&type=style&index=0&id=b832db44&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b832db44"]])

export default __exports__